<template>
    <div class="container">
        <div class="decoration">
            <img :src="logo" alt="logo LBF clair">
            <span class="material-symbols-outlined">lock</span>
            <p>L'accès à ce site est strictement réservé aux équipes de LaBienveillanceFinancière (LBF).</p>
        </div>

        <div class="form">
            <div>
                <h2>Connectez vous à votre compte</h2>

                <div class="form-section">
                    <label>Adresse e-mail</label>
                    <input type="email" v-model="email">
                </div>

                <div class="form-section">
                    <label>Mot de passe</label>
                    <input type="password" v-model="password">
                </div>

                <div class="ctrl">
                    <button @click="login">Se connecter</button>
                    <u>Mot de passe oublié</u>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import logo from '@/assets/images/LBF_logo_blanc.png';

export default {
    data() {
        return {
            logo: logo,
            email: "",
            password: "",
        }
    },
    methods: {
        async login() {
            try {
                const isAuthenticated = await this.$store.dispatch('serverAuthenticationFromPassword', {
                    email: this.email,
                    password: this.password,
                });
                
                if (isAuthenticated) {
                    this.$router.replace('/gestion');
                }

            } catch (err) {
                if (err.response?.data?.message) {
                    this.$store.commit('changeErrorMsg', err.response.data.message);
                } else {
                    this.$store.commit('changeErrorMsg', "Erreur lors de l'authentification");
                }
            }
        },
    }
}
</script>

<style scoped>
.container {
    display: flex;
    align-items: stretch;
    height: 100vh;
}

.decoration {
    position: relative;
    width: 40%;
    height: 100%;
    background-color: var(--color-main);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 20px;
    color: white;
}

.decoration img {
    position: absolute;
    height: 50px;
    top: 20px;
    left: 20px;
}

.form {
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
}

.form h2 {
    margin-bottom: 60px;
}

.form label,
.form input {
    font-size: 18px;
}

.ctrl {
    display: flex;
    gap: 8px;
    align-items: center;
}
</style>